<style lang="scss">
@import '@/weappTmps/comps/index.scss';
.color-picker {
  .color-select-box {
    border: 1px solid #dddee1;
    height: 24px;
    width: 60px;
    border-radius: 3px;
    padding: 2px;
  }
  .color-select {
    height: 100%;
  }
  .color-sketch-picker {
  }
}
.vc-sketch {
  z-index: 99999;
}
</style>

<template>
  <div class="color-picker horizontalLayout">
    <!-- <div class='horizontalLayout_title'>背景颜色</div> -->
    <div
      class="flex horizontalLayout_desc"
      placement="bottom"
      :transfer="true"
    >
      <el-popover
        class="color-sketch-picker"
        trigger="click"
        placement="right"
      >
        <sketch-picker v-model="skcolor" />
        <div
          slot="reference"
          class="color-select-box"
        >
          <div
            class="color-select"
            :style="{ backgroundColor: backgroundColor }"
          />
        </div>
      </el-popover>
      <span class="horizontalLayout_desc_text">{{ backgroundColor }} </span>
    </div>
  </div>
</template>

<script>
import { Sketch as sketchPicker } from 'vue-color'
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpBackgroundColor',
  components: {
    sketchPicker
  },
  mixins: [mixin],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      backgroundColor: this.value,
      skcolor: '',
      showColorPicker: false
    }
  },
  watch: {
    skcolor (newVal, oldVal) {
      console.log('skcolor-newVal', newVal)
      const { r, g, b, a } = newVal.rgba
      this.backgroundColor = `rgba(${r},${g},${b},${a})`
      // this.$emit('input', `rgba(${r},${g},${b},${a})`)
    }
  },
  created () {}
}
</script>
